;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var View = APP.module('View');

	View.TippingViewTipsListItem = Marionette.CompositeView.extend({
		template:   JST.TippingViewTipsListItem,
		tagName:    'tr',
		initialize: function () {
			this.matches = this.getOption('matches');
			this.model.set({
				avatars_url:       CONFIG.AVATARS_URL,
				matches_tip: this.matches,
				// tip_1:             this.model.get('tips')[0] ? this.getSquadUrl(this.model.get('tips')[0]) : '-',
				// tip_2:             this.model.get('tips')[1] ? this.getSquadUrl(this.model.get('tips')[1]) : '-',
				// tip_3:             this.model.get('tips')[2] ? this.getSquadUrl(this.model.get('tips')[2]) : '-',
				// tip_4:             this.model.get('tips')[3] ? this.getSquadUrl(this.model.get('tips')[3]) : '-',
				// tip_5:             this.model.get('tips')[4] ? this.getSquadUrl(this.model.get('tips')[4]) : '-',
				// tip_6:             this.model.get('tips')[5] ? this.getSquadUrl(this.model.get('tips')[5]) : '-',
				// tip_7:             this.model.get('tips')[6] ? this.getSquadUrl(this.model.get('tips')[6]) : '-',
				// tip_8:             this.model.get('tips')[7] ? this.getSquadUrl(this.model.get('tips')[7]) : '-',
				// tip_9:             this.model.get('tips')[8] ? this.getSquadUrl(this.model.get('tips')[8]) : '-',
				round_rank_change: this.getRoundChange(),
				rank:              this.model.get('rank') ? this.model.get('rank') : '-'
			});

			this.findTipForMatch();
		},

		findTipForMatch: function(){

			var tips = this.model.get('tips'),
				matches_with_tips = this.model.get('matches_tip');
			_.map(matches_with_tips, _.bind(function(val, key){
				val['predict_winner_squad_img'] = this.getSquadUrl(_.find(tips, {match_id: val.id}))
			}, this));

		},

		getSquadUrl: function (tip) {
			var resp = '-';
			if(tip){
				resp = '<img src="' + CONFIG.SQUADS_URL + tip.predict_winner_squad_id + '.png " alt="">';
			}
			return resp;
		},

		getRoundChange: function () {
			var prev_rank         = this.model.get('prev_rank'),
				rank              = this.model.get('rank'),
				round_rank_change = 0;
			if (!prev_rank || !rank) {
				return round_rank_change;
			}

			if (prev_rank < rank) {
				round_rank_change = 1;
			}

			if (prev_rank > rank) {
				round_rank_change = -1;
			}

			return round_rank_change;
		}

	});

}(window, APP, Backbone, Marionette, $, _));